var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24839 1.56616L3.65104 2.21491L1.62183 6.95163L3.18229 7.99226L4.46948 5.41882L5.2687 5.64851L4.56229 12.6844H11.4937L11.9249 8.56413L11.9671 8.18444H12.1781L11.9249 5.64851L12.7265 5.41882L14.0109 7.99226L15.5718 6.95163L13.5421 2.21491L10.9453 1.56616C10.6875 1.74757 10.3734 1.85726 10.0312 1.93882C9.59058 2.04241 9.0937 2.09069 8.59683 2.09069C8.09995 2.09069 7.60308 2.04241 7.16245 1.93882C6.82026 1.85726 6.5062 1.74804 6.24839 1.56616ZM12.7265 9.02819L12.6562 9.68444H21.0374L20.9671 9.02819H12.7265ZM12.5671 10.5282L11.3156 22.4344H14.2546L16.4343 12.2673H17.2593L19.439 22.4344H22.3781L21.1265 10.5282H12.5671Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListedIcon);
export default __webpack_public_path__ + "static/media/listed_icon.19d2efe1367bb6b941a9be65f945e329.svg";
export { ForwardRef as ReactComponent };